module.exports = __webpack_public_path__ + "static/media/10.c5671923.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/10.png
// module id = 1251
// module chunks = 0